import * as React from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'

export interface SearchFloatingPanelProps {
  title: string
  isOpen?: boolean
  children: React.ReactNode
  confirmText?: string
  onConfirm?: () => void
  onClose: () => void
  onGoBack: () => void
  isConfirmButtonHidden?: boolean
  confirmButtonDisabled?: boolean
  secondaryActionText?: string
  onSecondaryActionClick?: () => void
  footerContent?: React.ReactNode
}

const SearchFloatingPanel = React.forwardRef<HTMLDivElement, SearchFloatingPanelProps>((props, ref) => {
  const {
    title,
    isOpen,
    confirmText,
    onConfirm,
    onClose,
    onGoBack,
    children,
    isConfirmButtonHidden,
    confirmButtonDisabled,
    secondaryActionText,
    onSecondaryActionClick,
    footerContent,
  } = props

  const primaryActionProps = React.useMemo(() => ({
    children: confirmText,
    disabled: confirmButtonDisabled,
    onClick: onConfirm,
  }), [confirmButtonDisabled, confirmText, onConfirm])

  const secondaryActionProps = React.useMemo(() => ({
    children: secondaryActionText,
    onClick: onSecondaryActionClick,
  }), [onSecondaryActionClick, secondaryActionText])

  return (
    <ModalBase
      mode="drawer"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalHeader
        title={title}
        onBackButtonClick={onGoBack}
        onCloseButtonClick={onClose}
      />
      <ModalBody ref={ref}>
        <ModalContent flushListItems>
          {children}
        </ModalContent>
      </ModalBody>
      {(confirmText || secondaryActionText || footerContent) && (
        <ModalFooter
          isPrimaryActionHidden={isConfirmButtonHidden}
          primaryActionProps={primaryActionProps}
          secondaryActionProps={secondaryActionProps}
        >
          {footerContent}
        </ModalFooter>
      )}
    </ModalBase>
  )
})

SearchFloatingPanel.displayName = 'SearchFloatingPanel'

export default SearchFloatingPanel
